<script setup>
import { computed } from 'vue';
import ConversationStarters from 'widget/components/ConversationStarters.vue';

// The widget reads its own channel config; the settings preview passes the
// values being edited, which have not been saved yet.
const props = defineProps({
  heading: { type: String, default: null },
  tagline: { type: String, default: null },
  starters: { type: Array, default: null },
});

const emit = defineEmits(['select']);

const channelConfig = window.chatwootWebChannel || {};

const title = computed(() => props.heading ?? channelConfig.welcomeTitle);
const subtitle = computed(() => props.tagline ?? channelConfig.welcomeTagline);
</script>

<template>
  <div class="flex flex-col justify-between flex-1 w-full min-h-full px-2 py-4">
    <div class="flex flex-col items-center justify-center flex-1 gap-2 px-4">
      <h2
        v-if="title"
        class="text-2xl font-medium leading-tight tracking-tight text-center text-transparent bg-gradient-to-r from-[#346bf0] via-[#3186ff] to-[#4ea0ff] bg-clip-text"
      >
        {{ title }}
      </h2>
      <p v-if="subtitle" class="text-sm text-center text-n-slate-11">
        {{ subtitle }}
      </p>
    </div>

    <ConversationStarters
      :items="starters"
      @select="emit('select', $event)"
    />
  </div>
</template>
